/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ArchivedReportFlowContainer_settings = {
    readonly organization: {
        readonly name: string;
        readonly contactEmail: string;
    };
    readonly " $refType": "ArchivedReportFlowContainer_settings";
};
export type ArchivedReportFlowContainer_settings$data = ArchivedReportFlowContainer_settings;
export type ArchivedReportFlowContainer_settings$key = {
    readonly " $data"?: ArchivedReportFlowContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"ArchivedReportFlowContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ArchivedReportFlowContainer_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "Organization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "contactEmail",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '41580746ea4ea52bb9deb389c5582855';
export default node;
